<template>
  <div class="qb-articles-status">
    <label class="text-lg text-orange">Article Status</label>
    <input-select
      :selectedValue="queryArticleStatus"
      :options="articleStatusOptions"
      :multiple="true"
      :allowEmpty="false"
      :onChange="onChangeArticleStatus"
    />
  </div>
</template>

<script>
import { ARTICLE_STATUS } from "../../config/const";
import InputSelect from "../form-components/input-select";

export default {
  components: {
    "input-select": InputSelect
  },

  props: {
    queryArticleStatus: {
      type: Array,
      required: true
    }
  },

  computed: {
    articleStatusOptions() {
      return [
        {
          value: ARTICLE_STATUS.CODED,
          label: this.$t("articles.statuses.coded")
        },
        {
          value: ARTICLE_STATUS.PUBLISHED_QC,
          label: this.$t("articles.statuses.published_qc")
        },
        {
          value: ARTICLE_STATUS.PUBLISHED_NOT_QC,
          label: this.$t("articles.statuses.published_not_qc")
        }
      ]
    }
  },

  methods: {
    onChangeArticleStatus (value) {
      this.$emit("setArticleStatus", { entity: "article_status", value: value })
    }
  }
}
</script>

<style lang="scss">
  @import "../../styles/components/coding-queries/articles-status";
</style>